<template>
  <div class="plugin_wrap offline_appointment--wrap layout">
    <button class="btn btn--primary" @click="toggle()">{{config.button}}</button>
    <Dialog :show="visible" wrapCls="offline_appointment" @hide="hide">
      <div class="header">线下门店预约</div>
      <div class="qrcode-wrap" v-if="config.src">
        <img class="qrcode-imgage" :src="config.src" />
      </div>
      <div class="txt-lines">
        <div class="txt-line">扫描二维码即刻预约线下门店护理</div>
        <div class="txt-line">感受奢华法式护理体验</div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/Dialog.vue';

export default {
  name: "OfflineAppointment",
  components: { Dialog },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return { visible: false };
  },
  methods: {
    toggle() {
      if (this.visible) this.hide();
      else this.show();
    },
    show() { this.visible = true; },
    hide() { this.visible = false; }
  }
}
</script>

<style lang="scss" scoped>
  .offline_appointment--wrap {
    padding: 1rem 0;
    .btn--primary { display: block; margin: 0 auto; }
  }
  ::v-deep .offline_appointment .dialog-container {
    width: 285px; height: 346px;
    .dialog-body {
      flex-direction: column; justify-content: flex-start; align-items: center;
      .header {
        width: 100%; margin-top: 40px; font-size: 16px; color: #000; font-weight: 700; line-height: 22px; text-align: center;
      }
      .qrcode-wrap {
        width: 156px; height: 156px; margin: 30px auto; position: relative;
        .qrcode-imgage { width: 100%; }
      }
      .txt-lines {
        width: 100%; text-align: center;
        .txt-line { font-size: 12px; color: #000; }
      }
    }
  }

  @media screen and (min-width: 48em) {
    ::v-deep .offline_appointment .dialog-container {
      width: 470px; height: 436px;
      .dialog-body {
        .header { margin-top: 50px; font-size: 18px; line-height: 25px; }
        .qrcode-wrap {
          margin: 50px auto 36px auto;
          width: 174px; height: 174px; 
        }
        .txt-lines .txt-line { font-size: 14px; }
      }
    }
  }
</style>